import React from 'react'
import { Col } from 'reactstrap'
import  CardForm from 'components/Common/card-form'

export default (props) => (
    <Col xs="12"> 
        <div className="card-details-panel d-flex justify-content-center">
            <CardForm from='CARD' canDisplaySaveCard={true} t={props.t} />
        </div>
    </Col>
)